/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React, { useEffect } from 'react';
import queryString from 'query-string';

import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';
import { Container, Row, Col } from 'reactstrap';

import './style.scss';
import logo from './img/logo.jpg'
import LoginForm from './LoginForm';

const Login = ({ location, translate }) => {
  useEffect(() => {
    document.title = 'digital';
    document.body.style.backgroundColor = '#f2f2f2';
  });
  const api = new ServiceApi();
  const parameters = queryString.parse(location.search);
  const _validateParams = () => {
    if (!parameters.client_id || !parameters.redirect_uri || !parameters.response_type)
      return false;
    return true;
  }

  return (
    <Container fluid={true} className="digital-body">
      <Row className="digital-head">
        <Col sm="12" xs="12" md="12" style={{padding:0}}>
          <img src={logo} alt="logo" className="logo-digital rounded mx-auto d-block" />
        </Col>
      </Row>
      <Row style={{ margin: 0 }}>
        <Col>
          {
            _validateParams()
              ? <LoginForm
                api={api}
                location={location}
              />
              : <RequestLoginErrorMessage
                onlyMessage={true}
                message={translate('RequestLoginErrorMessage')}
              />
          }
        </Col>
      </Row>
    </Container>
  );
}

export default Login;
